import ImageIcon from '@mui/icons-material/Image';
import { Button, Grid, TextField, Tooltip, MenuItem } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from '@mui/material/Divider';
import React, { useRef, useState } from "react";
import AttribuerDroit from './AttributionDroit/AttribuerDroit';
import { useSelector } from 'react-redux';
import { IReduxState } from '../../../store';
import { IUtilisateur } from './utilisateurAppGestionInterneSlice';

interface IEddProps {
  editUser: any
  setEditUser: (x: any) => void
  arrayToEdit: any
  setArrayToEdit: (x: any) => void
}


export interface IEditionPayload {

}

const Edit = (props: IEddProps) => {
  //props
  const { editUser, setEditUser, arrayToEdit, setArrayToEdit } = props

  //redux
  const { typeUtilisateurs, personnes, agents } = useSelector((editUser: IReduxState) => editUser.utilisateurAppGestionInterne);


  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setEditUser({ ...editUser, [name]: value })
  }

  const getAgent = (idPersonne: number) => {
    return personnes?.find(p => p.idPersonne === idPersonne)
  }


  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={2}
      >
        <Grid item md={4} xs={12} sm={4}>
          <Grid
            container
            spacing={2}
          >

            <Grid item xs={12} sm={12} md={12}>
              <TextField
                fullWidth
                select
                size="small"
                name="idPersonne"
                label="Selectionner une personne"
                value={editUser.idPersonne}
                onChange={handleInputChange}
                disabled
              >
                {agents.map((option) => (
                  <MenuItem key={option.idPersonne} value={option.idPersonne}>
                    {`${getAgent(option.idPersonne)?.nom} ${getAgent(option.idPersonne)?.prenom}`}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <TextField
                fullWidth
                select
                size="small"
                name="idTypeUtilisateur"
                label="Type utilisateur"
                value={editUser.idTypeUtilisateur}
                onChange={handleInputChange}
              >
                {typeUtilisateurs.map((option) => (
                  <MenuItem key={option.idTypeUtilisateur} value={option.idTypeUtilisateur}>
                    {option.libTypeUtilisateur}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <TextField
                fullWidth
                size="small"
                name="email"
                label="Email"
                value={editUser.email}
                onChange={handleInputChange}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={8} md={8}>
          {
            editUser.idTypeUtilisateur && editUser.idTypeUtilisateur !== 1 &&
            <AttribuerDroit
              rightsChecked={arrayToEdit}
              setRightsChecked={setArrayToEdit}
            />
          }
        </Grid>

      </Grid>
    </Box>
  );
};

export default Edit;





